import type { ReactNode } from 'react';
import { cx } from '../utils/cx';
import { ToneIcon } from './Badge';

export interface CalloutProps {
  tone?: 'info' | 'success' | 'warning' | 'danger';
  title: string;
  children?: ReactNode;
  /**
   * Annonce aux lecteurs d'écran : « alert » pour une erreur bloquante apparue après une
   * action, « status » pour une information, aucune pour un encadré statique.
   */
  live?: 'alert' | 'status';
  className?: string;
}

export function Callout({ tone = 'info', title, children, live, className }: CalloutProps) {
  return (
    <div role={live} className={cx('av-callout', `av-callout--${tone}`, className)}>
      <ToneIcon tone={tone} className="av-callout__icon" />
      <p className="av-callout__title">{title}</p>
      {children ? <div className="av-callout__body">{children}</div> : null}
    </div>
  );
}
